import Filters from '~/js/modules/filters';
import getSwiperSlider from '~/js/modules/slider';
import StockChart from '~/js/modules/stock-chart';
import Accordion from '~/js/modules/accordion';
import '~/js/modules/online-request';
import '~/js/modules/promo-banner';

window.addEventListener(`DOMContentLoaded`, () => {
  const productsSliders = document.querySelectorAll(`.products__slider-mobile`);
  const productsChartBlocks = document.querySelectorAll(`.products__chart-block`);
  const filterButtons = document.querySelectorAll(`.filters__link`);
  const accordions = document.querySelectorAll(`.accordion`);
  // const forms = document.querySelectorAll(`.form__form`);
  let productsSwipers = [{}, {}];

  if (accordions.length) {
    accordions.forEach((accordion) => {
      if (!accordion.classList.contains('main-nav__list') && !accordion.classList.contains('service-request--accordion')) {
        new Accordion(accordion)
      }
    });
  }

  const productContainers = document.querySelectorAll(`.products__cards`);
  if (productContainers.length) {
    productContainers.forEach((pc) => {
      let productCard = Array.from(pc.querySelectorAll('.products__actual'));

      productCard.forEach((card) => {
        card.dataset.growth = Number(card.dataset.growth.replace(',', '.'));
      });
      productCard.sort((a, b) => {
        return b.dataset.growth - a.dataset.growth;
      });

      productCard.forEach(productCard => pc.appendChild(productCard));
    });
  }

  const productsSwiperParams = {
    slidesPerView: `auto`,
    loop: false,
    autoplay: false,
    navigation: false,
    pagination: false,
  };

  if (window.innerWidth < 1024) {
    productsSliders.forEach((it, i) => {
      if (it) {
        productsSwipers[i] = getSwiperSlider(it, productsSwiperParams);
        it.swiper.update();
      }
    });

    if (filterButtons.length) {
      filterButtons.forEach((fb) => {
        fb.addEventListener('click', () => {
          productsSliders.forEach((it, i) => {
            if (it.swiper && it.swiper.initialized) {
              it.swiper.destroy();
            }
            productsSwipers[i] = setTimeout(getSwiperSlider, 100, it, productsSwiperParams);
          });
        })
      });
    }
  }

  const filtersControls = document.querySelectorAll(`.js-filters-controls`);
  if (filtersControls.length) {
    filtersControls.forEach((fc, i) => {
      new Filters(fc);

      productsSliders.forEach((it, i) => {
        if (it.swiper && it.swiper.initialized) {
          it.swiper.destroy();
        }
        productsSwipers[i] = setTimeout(getSwiperSlider, 100, it, productsSwiperParams);
      })
    });
  }

  const productsStockChartNames = [`MSFT`];
  const productsStockChartOptions = {
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    navigator: {
      enabled: false,
    },
    plotOptions: {
      line: {
        enableMouseTracking: false
      },
    },
    rangeSelector: {
      enabled: false,
    },
    scrollbar: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    xAxis: {
      crosshair: false,
      labels: {
        enabled: false,
      },
      lineWidth: 0,
      range: 365 * 24 * 60 * 60 * 1000, // 1 year
      tickLength: 0,
    },
    yAxis: {
      gridLineWidth: 0,
      labels: {
        enabled: false,
      },
    },
    series: [],
    seriesCounter: 0,
  };

  productsChartBlocks.forEach((chart, i) => {
    productsStockChartOptions.chart = {
      spacing: 0,
      width: chart.offsetWidth,
      height: chart.offsetHeight,
    };
    productsStockChartOptions.names = i >= productsStockChartNames.length - 1
      ? [productsStockChartNames[0]]
      : [productsStockChartNames[i]];

    return new StockChart({
      chart,
      options: productsStockChartOptions,
    });
  });

  window.addEventListener(`resize`, () => {
    if (window.innerWidth >= 1024) {
      productsSwipers.forEach((it) => {
        if (it.initialized) {
          it.destroy();
        }
      });
    } else {
      productsSwipers.forEach((it, i) => {
        if (!it.initialized) {
          productsSwipers[i] = getSwiperSlider(productsSliders[i], productsSwiperParams);
        }
      });
    }
  });
});
